import React, { useEffect, useState } from "react";
import { getBusinessUserList } from "../../../Services/getBusinessUserList";
import SearchYellowIcon from '../../../../../images/home-landing-page/search-yellow-icon.png';
import { jwtDecode } from "jwt-decode";
import EmptyProfileImage from '../../../../../images/navbar/empty-profile-image.png'
import '../../../../../styles/messages.css';
import '../../../../../styles/responsive.css';

function Conversation({ setActiveConversation, unreadMessages, setHomeData })
{
    // State to hold the search input value
    const [searchTerm, setSearchTerm] = useState("");
    const [conversations, setConversations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeConversationId, setActiveConversationId] = useState(null);
    const [selectedQuoteId, setSelectedQuoteId] = useState(null);
    // Filter conversations based on the search term
    const filteredConversations = conversations.filter((conversation) =>
        conversation.userName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const unreadActiveMessages = async () =>
    {
        try
        {
            if (unreadMessages !== null)
            {
                unreadMessages.num = 0;
            }
        }
        catch (e)
        {
            console.log(e);
        }
    }

    useEffect(() =>
    {
        const getConversations = async () =>
        {
            try
            {
                setLoading(true);
                const token = localStorage.getItem('token');
                if (token !== null)
                {
                    const decodeToken = jwtDecode(token);
                    const businessUserid = decodeToken.nameid;
                    const data = await getBusinessUserList(businessUserid);
                    setConversations(data);
                }

            } catch (error)
            {
                setError("Failed to load conversation list.");
            } finally
            {
                setLoading(false);
            }
        };

        getConversations();
    }, []);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>{error}</div>;

    return (
        <div >
            {/*
            <h4>Messages</h4>
            */}
            <div class="chat-search">
                <input
                    type="text"
                    placeholder="Search chat"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                <img src={SearchYellowIcon} />
            </div>

            <div class="chat-persons-list">
                {filteredConversations.map((conversation, index) => (
                    <React.Fragment key={index}>
                        <div
                            onClick={() =>
                            {
                                unreadActiveMessages();
                                setActiveConversation(conversation);
                                setActiveConversationId(conversation.userId);
                                setSelectedQuoteId(conversation?.quoteId);
                                setHomeData(conversation);
                                // Update the conversation's unreadMessages to 0
                                setConversations(prevConversations =>
                                    prevConversations.map(conv =>
                                        conv.conversationId === conversation.conversationId
                                            ? { ...conv, unreadMessages: 0 } // Mark as read
                                            : conv // Keep other conversations unchanged
                                    )
                                );
                            }}
                            className={`chat-person-box ${(activeConversationId === conversation.userId &&
                                (selectedQuoteId === conversation?.quoteId)) ? "active" : ""}`}>
                            <figure>
                                <img
                                    src={conversation?.userProfileUrl == null ? EmptyProfileImage : conversation?.userProfileUrl}
                                    alt={conversation.userName} />
                            </figure>

                            <div className="chat-person-detail">
                                <div className="chat-person-name-date">
                                    <p>{conversation?.userName}</p> <span> {formatTimeDifference(conversation?.updatedDate) ||
                                        "Just now"}</span>
                                </div>
                                <p className="chat-hint">
                                    <span className="chat-hint-text">{conversation?.lastMessage || ""}</span>
                                    {(conversation?.unreadMessages !== 0) ? (
                                        <span className="incoming-msg">{conversation?.unreadMessages}</span>
                                    ) : (unreadMessages?.num !== 0 || unreadMessages != null) && unreadMessages?.conversationId === conversation?.conversationId ? (
                                        <span className={`${unreadMessages?.num != 0 ? "incoming-msg" : ""}`}>{unreadMessages?.num != 0 ? unreadMessages?.num : ""}</span>
                                    ) : ""}

                                </p>
                            </div>
                        </div>
                    </React.Fragment>
                ))}
            </div>
        </div >

    );
}

// Helper function to calculate time difference
function formatTimeDifference(dateString)
{
    if (!dateString) return null;

    const updatedDate = new Date(dateString);
    const now = new Date();
    const diffMinutes = Math.floor((now - updatedDate) / (1000 * 60));

    if (diffMinutes < 1) return "Just now";
    if (diffMinutes < 60) return `${diffMinutes} min`;
    const diffHours = Math.floor(diffMinutes / 60);
    if (diffHours < 24) return `${diffHours} hr`;
    const diffDays = Math.floor(diffHours / 24);
    return `${diffDays} day${diffDays > 1 ? "s" : ""}`;
}

export default Conversation;